import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { faPlay, faTimes, faToggleOn, faToggleOff, faCheckSquare, faSquare } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from '../button/button.component';
import { Configuration } from '../../services/configurations.service';

export interface ProcessingExecuteOptions {
  delfos_server_config_id: string | null;
  delfos_llm_config_id: string | null;
  ai_model_language: 'pt' | 'en' | 'es';
  clear_delfos_cache: boolean;
  save_as_default: boolean;
}

@Component({
  selector: 'app-modal-execute-processing',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule, TranslateModule, NgSelectModule, ButtonComponent],
  templateUrl: './modal-execute-processing.component.html',
  styleUrls: ['./modal-execute-processing.component.scss'],
})
export class ModalExecuteProcessingComponent {
  faPlay = faPlay;
  faTimes = faTimes;
  faToggleOn = faToggleOn;
  faToggleOff = faToggleOff;
  faCheckSquare = faCheckSquare;
  faSquare = faSquare;

  @Input() delfosServerConfigs: Configuration[] = [];
  @Input() delfosLlmConfigs: Configuration[] = [];

  @Input() set initialOptions(opts: Partial<ProcessingExecuteOptions> | null) {
    this._initialOptions = opts;
  }
  private _initialOptions: Partial<ProcessingExecuteOptions> | null = null;

  @Input() set show(val: boolean) {
    const wasClosed = !this._show && val;
    this._show = val;
    if (wasClosed) {
      this.resetOptions();
      if (this._initialOptions) {
        this.options = { ...this.options, ...this._initialOptions };
      }
    }
  }
  get show(): boolean {
    return this._show;
  }
  private _show = false;

  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<ProcessingExecuteOptions>();

  options: ProcessingExecuteOptions = {
    delfos_server_config_id: null,
    delfos_llm_config_id: null,
    ai_model_language: 'pt',
    clear_delfos_cache: false,
    save_as_default: false,
  };

  aiModelLanguageOptions = [
    { value: 'pt', label: 'SETTINGS.PREFERENCES.AI_MODEL_LANGUAGE_OPTIONS.PT' },
    { value: 'en', label: 'SETTINGS.PREFERENCES.AI_MODEL_LANGUAGE_OPTIONS.EN' },
    { value: 'es', label: 'SETTINGS.PREFERENCES.AI_MODEL_LANGUAGE_OPTIONS.ES' },
  ];

  private resetOptions(): void {
    this.options = {
      delfos_server_config_id: null,
      delfos_llm_config_id: null,
      ai_model_language: 'pt',
      clear_delfos_cache: false,
      save_as_default: false,
    };
  }

  toggleOption(key: 'clear_delfos_cache' | 'save_as_default'): void {
    this.options[key] = !this.options[key];
  }

  get showDelfosServer(): boolean {
    return this.delfosServerConfigs.length > 1;
  }

  onConfirm(): void {
    this.confirm.emit(this.options);
  }

  onClose(): void {
    this.close.emit();
  }
}
